// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.manage-header-container {
  text-align: start;
  margin-left: 26px;
}
.manage-header-container h4 {
  font-weight: 700;
  color: #444343;
}

.select-label {
  font-weight: 500;
}
.select-label div {
  margin-bottom: 4px;
}

.grade-container {
  border-radius: 4px;
  background-color: #EDF0F1;
  border: 1px solid #D1D3D4;
  margin-top: 20px;
  padding: 32px;
}

.plo-checkbox {
  margin-right: 12px;
}

.grade-name {
  color: #0669B3;
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 16px;
}

.standard-name {
  font-weight: 600;
  margin-left: 24px;
}

.grades-wrapper {
  margin-top: 24px;
}
.grades-wrapper .select-grade-label {
  font-weight: 500;
  margin-bottom: 8px;
}

.grade-btn-container {
  margin-top: 8px;
  flex-wrap: wrap;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.content-status-on-grade-button {
  position: relative;
  bottom: 54px;
  left: 70px;
}

.selection-container {
  border-radius: 4px;
  background-color: rgba(192, 222, 240, 0.5);
  border: 1px solid #c0def0;
  padding: 24px;
  margin: 16px auto;
  width: 95%;
}

.outcomes-container {
  width: 95%;
  margin: auto;
}

.content-title {
  margin-bottom: 0px;
}

.selectable-input-wrapper {
  align-items: center;
  display: flex;
}
.selectable-input-wrapper input {
  transform: scale(1.3);
}

.reportable-content-wrapper {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  line-height: 1.5;
}

.reportable-content-wrapper-accordion {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  justify-content: space-between;
  width: 100%;
}
.reportable-content-wrapper-accordion :focus {
  background-color: #CFE2FF;
}

.rc-accordion-body {
  line-height: 1.5;
}

.rc-accordion-title {
  display: flex;
  width: 100%;
}
.rc-accordion-title input {
  margin: 0px 4px 0px 0px;
}

.epr-save-btn {
  width: 95%;
  margin: 12px auto;
  display: flex;
  justify-content: flex-end;
}

.number-circle {
  position: relative;
  bottom: 54px;
  left: 70px;
  background: white;
  border: 1px solid #444343;
  border-radius: 50%;
  color: #444343;
  height: 24px;
  padding: 4px;
  width: 24px;
}
.number-circle .count-in-circle {
  align-items: center;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  height: 100%;
  justify-content: center;
}

.missing {
  color: #CB321A;
  border: 2px solid #CB321A;
}

.selectable-content-label {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-right: 16px;
  width: 100%;
}

.read-selected-header-label {
  border-radius: 8px;
  background-color: rgba(192, 222, 240, 0.3);
  padding: 4px 0px;
}

.read-selected-child-label {
  border-radius: 8px;
  align-items: flex-start;
  background-color: rgba(192, 222, 240, 0.3);
  display: flex;
  padding: 4px 8px;
}

.selectable-child-label {
  align-items: flex-start;
  display: flex;
  padding: 4px 8px;
}

.content-area-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 5px;
}

.square-wrapper {
  min-height: 25px;
  min-width: 25px;
}

.italic {
  font-style: italic;
}

.active-check-input {
  margin-right: 8px;
  margin-top: 6px;
  transform: scale(1.2);
}

.no-content-avail-msg {
  background: white;
  border: 1px solid #808080;
  border-radius: 5px;
  padding: 8px 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ManageEprContent.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,iBAAA;EACA,iBAAA;AAUJ;AARI;EACI,gBAAA;EACA,cDuBC;ACbT;;AANA;EACI,gBAAA;AASJ;AAPI;EACI,kBAAA;AASR;;AALA;EClBI,kBDmBsB;EACtB,yBDGI;ECFJ,yBAAA;EACA,gBAAA;EACA,aAAA;AAQJ;;AALA;EACI,kBAAA;AAQJ;;AALA;EACI,cDDS;ECET,gBAAA;EACA,eAAA;EACA,mBAAA;AAQJ;;AALA;EACI,gBAAA;EACA,iBAAA;AAQJ;;AALA;EACI,gBAAA;AAQJ;AANI;EACI,gBAAA;EACA,kBAAA;AAQR;;AAHA;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AAMJ;;AAHA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AAMJ;;AAHA;EClEI,kBDmEsB;EACtB,0CAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;AAMJ;;AAHA;EACI,UAAA;EACA,YAAA;AAMJ;;AAHA;EACI,kBAAA;AAMJ;;AAHA;EACI,mBAAA;EACA,aAAA;AAMJ;AAJI;EACI,qBAAA;AAMR;;AAFA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAKJ;;AAFA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;AAKJ;AAHI;EACI,yBAAA;AAKR;;AADA;EACI,gBAAA;AAIJ;;AADA;EACI,aAAA;EACA,WAAA;AAIJ;AAFI;EACI,uBAAA;AAIR;;AAAA;EACI,UAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EAEA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cD/GK;ECgHL,YAAA;EACA,YAAA;EACA,WAAA;AAEJ;AAAI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AAER;;AAEA;EACI,cD7IE;EC8IF,yBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;ECxKI,kBDyKsB;EACtB,0CAAA;EACA,gBAAA;AACJ;;AAEA;EC9KI,kBD+KsB;EACtB,uBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAGA;EC7LI,kBD8LsB;EACtB,yBAAA;EACA,cDnKK;ECoKL,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,eAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.manage-header-container {\n    text-align: start;\n    margin-left: 26px;\n\n    h4 {\n        font-weight: 700;\n        color: $grey4a;\n    }\n}\n\n.select-label {\n    font-weight: 500;\n\n    div {\n        margin-bottom: 4px;\n    }\n}\n\n.grade-container {\n    @include borderRadius(4px);\n    background-color: $grey0;\n    border: 1px solid $grey1;\n    margin-top: 20px;\n    padding: 32px;\n}\n\n.plo-checkbox {\n    margin-right: 12px;\n}\n\n.grade-name {\n    color: $pearl-blue;\n    font-weight: 600;\n    font-size: 24px;\n    margin-bottom: 16px;\n}\n\n.standard-name {\n    font-weight: 600;\n    margin-left: 24px;\n}\n\n.grades-wrapper {\n    margin-top: 24px;\n\n    .select-grade-label {\n        font-weight: 500;\n        margin-bottom: 8px;\n    }\n\n}\n\n.grade-btn-container {\n    margin-top: 8px;\n    flex-wrap: wrap;\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n}\n\n.content-status-on-grade-button {\n    position: relative;\n    bottom: 54px;\n    left: 70px;\n}\n\n.selection-container {\n    @include borderRadius(4px);\n    background-color: rgba(192, 222, 240, 0.5);\n    border: 1px solid $pale-blue;\n    padding: 24px;\n    margin: 16px auto;\n    width: 95%\n}\n\n.outcomes-container {\n    width: 95%;\n    margin: auto;\n}\n\n.content-title {\n    margin-bottom: 0px;\n}\n\n.selectable-input-wrapper {\n    align-items: center;\n    display: flex;\n\n    input {\n        transform: scale(1.3);\n    }\n}\n\n.reportable-content-wrapper {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 8px;\n    line-height: 1.5;\n}\n\n.reportable-content-wrapper-accordion {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 8px;\n    justify-content: space-between;\n    width: 100%;\n\n    :focus {\n        background-color: #CFE2FF;\n    }\n}\n\n.rc-accordion-body {\n    line-height: 1.5;\n}\n\n.rc-accordion-title {\n    display: flex;\n    width: 100%;\n\n    input {\n        margin: 0px 4px 0px 0px;\n    }\n}\n\n.epr-save-btn {\n    width: 95%;\n    margin: 12px auto;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.number-circle {\n    position: relative;\n    bottom: 54px;\n    left: 70px;\n\n    background: white;\n    border: 1px solid $grey4a;\n    border-radius: 50%;\n    color: $grey4a;\n    height: 24px;\n    padding: 4px;\n    width: 24px;\n\n    .count-in-circle {\n        align-items: center;\n        display: flex;\n        font-size: 14px;\n        font-weight: 500;\n        height: 100%;\n        justify-content: center;\n    }\n}\n\n.missing {\n    color: $red;\n    border: 2px solid $red;\n}\n\n.selectable-content-label {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-right: 16px;\n    width: 100%;\n}\n\n.read-selected-header-label {\n    @include borderRadius(8px);\n    background-color: rgba(192, 222, 240, 0.3);\n    padding: 4px 0px;\n}\n\n.read-selected-child-label {\n    @include borderRadius(8px);\n    align-items: flex-start;\n    background-color: rgba(192, 222, 240, 0.3);\n    display: flex;\n    padding: 4px 8px;\n}\n\n.selectable-child-label {\n    align-items: flex-start;\n    display: flex;\n    padding: 4px 8px;\n}\n\n\n.content-area-select {\n    @include borderRadius(5px);\n    border: 1px solid $grey3;\n    color: $grey4a;\n    padding: 5px;\n}\n\n.square-wrapper {\n    min-height: 25px;\n    min-width: 25px;\n}\n\n.italic {\n    font-style: italic;\n}\n\n.active-check-input {\n    margin-right: 8px;\n    margin-top: 6px;\n    transform: scale(1.2);\n}\n\n.no-content-avail-msg {\n    background: white;\n    border: 1px solid $grey3;\n    border-radius: 5px;\n    padding: 8px 12px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
